import axios from 'axios';
import { IPage, IPageTemplate } from '@/types/page';
import { TNodes } from '@/types/node';
import { AxiosResponse } from 'axios';

export type Actions = {
  loading: boolean;
  loadPages: () => Promise<void>;
  createPage: (template: IPageTemplate) => Promise<IPage>;
  updatePage: (page: IPage, nodes: TNodes) => Promise<void>;
  deletePage: (pageId: string) => Promise<void>;
};

export const fetchPagesService = (
  conferenceId: string
): Promise<AxiosResponse<IPage[]>> =>
  axios.get(`/api/conferences/${conferenceId}/pages`);

export const fetchPagesMapService = (
  conferenceId: string
): Promise<
  AxiosResponse<Record<string, Pick<IPage, 'id' | 'slug' | 'locked'>>>
> => axios.get(`/api/conferences/${conferenceId}/pagesmap`);

export const fetchPageByIdService = (
  conferenceId: string,
  pageId: string
): Promise<AxiosResponse<IPage>> =>
  axios.get(`/api/conferences/${conferenceId}/pages/${pageId}`);

export const fetchPageBySlugService = (
  conferenceId: string,
  slug: string
): Promise<AxiosResponse<IPage>> =>
  axios.get(`/api/visitor/conferences/${conferenceId}/pages/?slug=${slug}`);

export const addPageService = (
  conferenceId: string,
  data?: Partial<IPage>
): Promise<AxiosResponse<IPage>> =>
  axios.post(`/api/conferences/${conferenceId}/pages`, data);

export const duplicatePageService = (
  conferenceId: string,
  pageId: string,
  data?: Partial<IPageTemplate>
): Promise<AxiosResponse<IPage>> =>
  axios.post(`/api/conferences/${conferenceId}/pages/${pageId}`, data);

export const updatePageService = (
  conferenceId: string,
  page: IPage,
  nodes: TNodes
): Promise<AxiosResponse<IPage>> =>
  axios.put(`/api/conferences/${conferenceId}/pages/${page.id}`, { page, nodes });

export const deletePageService = (conferenceId: string, pageId: string) =>
  axios.delete(`/api/conferences/${conferenceId}/pages/${pageId}`);
